import { tEnum } from "@components/i18n";
import { CamelCaseKeys } from "@utils/typescript";
import { UserLess } from "./User";

export enum ImportStatuses {
  Progressing = 'progressing',
  Done = 'done',
}

export enum ImportTypes {
  Car = 'car',
  AddUsers = 'add_users',
  DeactivateUsers = 'deactivate_users',
}

export type ImportModel = CamelCaseKeys<{
  id: number;
  status: ImportStatuses;
  import_type: ImportTypes;
  success_count: number[];
  errors_count: number[];
  skips_count: number[];
  created_at: number;
  data_csv: string;
  result_csv?: string;
  creator?: UserLess;
  proof?: string;
}>;

export const tImportStatuses = (status: ImportStatuses) => tEnum('importStatuses', status);
export const tImportTypes = (type: ImportTypes) => tEnum('importTypes', type);
